// @ts-nocheck
import React, {useContext, useEffect, useState} from "react";
import Loading from "./Serving/Loading.tsx";
import * as ApiCalls from "./Serving/ApiCalls";

import {azureTokenContext, userIdContext} from "../App.tsx";

import moment from "moment";
import "moment/locale/nb";

import {styled} from "@mui/material/styles";
import {DataGridPremium, GridToolbarQuickFilter} from "@mui/x-data-grid-premium";
import Box from "@mui/material/Box";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";

import "../style/statistics.css";

export default function Statistics() {
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);

    const [loadingStatus, setLoadingStatus] = useState("loading");
    const [stats, setStats] = useState<any>({});
    const [rows, setRows] = useState([]);
    const [pageSize, setPageSize] = React.useState(10);

    useEffect(() => {
        ApiCalls.contentReviewerStats(userId, azureToken)
            .then((response) => {
                setRowsFunc(response);
                log("INFO", "Get statistics table success", "statistics table", "", "");
            })
            .catch((err) => {
                setLoadingStatus("error");
                console.error("get contentReviewer stats fail", err);
                log("ERROR", "Get statistics table fail", "statistics table", "", "");
            });
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const setRowsFunc = (response) => {
        setLoadingStatus("done");
        setStats(response.Result);
        setRows(
            response.Result.map(function (element, i) {
                return {
                    id: i,
                    Stat: element,
                    Source: element.Source,
                    DocumentId: element.DocumentId,
                    DocumentTitle: element.DocumentTitle,
                    AuthorId: element.AuthorId,
                    AuthorName: element.AuthorName,
                    AuthorEmail: element.AuthorEmail,
                    NumberOfSubIds: element.NumberOfSubIds,
                    NumberOfNotes: element.NumberOfNotes,
                    WorkItemCount: element.WorkItemCount,
                    FirstPublishedDate: element.FirstPublishedDate,
                    LastPublishedDate: element.LastPublishedDate,
                    LastAuthorValidatedDate: element.LastAuthorValidatedDate,
                };
            })
        );
    };

    const setRowsPerPageOptionsArray = () => {
        const length = stats.length;
        const result = [10];
        if (length > 10) {
            if (length <= 20) {
                result.push(length);
            } else {
                result.push(20);
                if (length <= 50) {
                    result.push(length);
                } else {
                    result.push(50);
                    if (length <= 100) {
                        result.push(length);
                    } else {
                        result.push(100);
                        result.push(length);
                    }
                }
            }
        }
        return result;
    };

    const NoRowDisplay = () => {
        return (
            <div>
                <p className="noRowDisplay">Ingen statistikk tilgjengelig!</p>
            </div>
        );
    };

    const HtmlTooltip = styled(({className, ...props}) => <Tooltip {...props} classes={{popper: className}}/>)(
        ({theme}) => ({
            [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: "#f5f5f9",
                color: "rgba(0, 0, 0, 0.87)",
                fontSize: theme.typography.pxToRem(13),
                border: "1px solid #dadde9",
            },
        })
    );

    const authorNameTemplate = (props: any) => {
        const stat = props.row.Stat;
        if (stat) {
            const mailtoLink = `mailto:${stat.AuthorEmail}`;
            return (
                <HtmlTooltip
                    title={
                        <React.Fragment>
                            <a href={mailtoLink} target="_blank" rel="noreferrer">
                                {stat.AuthorEmail}
                            </a>
                        </React.Fragment>
                    }
                >
                    <p className="stat-author-name">{stat.AuthorName}</p>
                </HtmlTooltip>
            );
        }
        return " - ";
    };

    const firstPublishedDateTemplate = (props) => {
        const stat = props.row.Stat;
        if (stat && stat.FirstPublishedDate) {
            return moment(stat.FirstPublishedDate).format("ll");
        }
        return " - ";
    };

    const lastPublishedDateTemplate = (props) => {
        const stat = props.row.Stat;

        if (stat && stat.LastPublishedDate) {
            return moment(stat.LastPublishedDate).format("ll");
        }
        return " - ";
    };

    const lastAuthorValidatedDateTemplate = (props) => {
        const stat = props.row.Stat;
        if (stat && stat.LastAuthorValidatedDate) {
            const daysDiff = dateDifferenceInDays(stat.LastPublishedDate);
            const dateString = moment(stat.LastAuthorValidatedDate).format("ll");
            if (daysDiff < 330) {
                return dateString;
            } else {
                return <p
                    className={`dateColorification ${daysDiff < 365 ? "yellowBackground" : "redBackground"}`}>{dateString}</p>;
            }
        } else {
            return " - ";
        }
    };

    const dateDifferenceInDays = (date) => {
        if (date) {
            const now = moment();
            const momentDate = moment(date);
            return now.diff(momentDate, "days");
        } else {
            return null;
        }
    };

    const renderNumbers = (props) => {
        const number = props.row.Stat[props.field];
        return <span className="stat-number">{number}</span>;
    };

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter/>
            </Box>
        );
    }

    const columns = [
        {
            field: "DocumentTitle",
            headerName: "Publikasjon",
            width: 350,
            headerClassName: "gridHeader",
            // hide: true,
        },
        {
            field: "DocumentId",
            headerName: "Lovnummer",
            width: 110,
            headerClassName: "gridHeader",
            // hide: true,
        },

        {
            field: "AuthorName",
            headerName: "Forfatter",
            width: 150,
            headerClassName: "gridHeader",
            renderCell: authorNameTemplate,
        },
        {
            field: "FirstPublishedDate",
            headerName: "Første publisering",
            width: 140,
            headerClassName: "gridHeader",
            renderCell: firstPublishedDateTemplate,
        },
        {
            field: "LastPublishedDate",
            headerName: "Siste publisering",
            width: 120,
            headerClassName: "gridHeader",
            renderCell: lastPublishedDateTemplate,
        },
        {
            field: "LastAuthorValidatedDate",
            headerName: "Siste hovedrevidert",
            width: 130,
            headerClassName: "gridHeader",
            renderCell: lastAuthorValidatedDateTemplate,
        },
        {
            field: "NumberOfSubIds",
            headerName: "Antall paragrafer",
            width: 120,
            headerClassName: "gridHeader",
            renderCell: renderNumbers,
        },
        {
            field: "NumberOfNotes",
            headerName: "Antall notater",
            width: 120,
            headerClassName: "gridHeader",
            renderCell: renderNumbers,
        },
        {
            field: "WorkItemCount",
            headerName: "Antall aktive oppgaver",
            width: 150,
            headerClassName: "gridHeader",
            renderCell: renderNumbers,
        },
    ];

    const log = (level, message, method, workItemId, userRole) => {
        ApiCalls.log(level, message, method, workItemId, userRole, userId, azureToken);
    };

    return (
        <>
            <>{loadingStatus === "loading" && <Loading/>}</>
            <>
                {loadingStatus === "done" && (
                    <div className="StatisticsContainer">
                        <h3 className="StatisticsHeader">Statistikk</h3>
                        <div className="StatisticsTable">
                            <DataGridPremium
                                rows={rows}
                                columns={columns}
                                getRowHeight={() => "auto"}
                                getRowClassName={() => "gridRow"}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={setRowsPerPageOptionsArray()}
                                pagination={true}
                                components={{
                                    NoRowsOverlay: NoRowDisplay,
                                    Toolbar: QuickSearchToolbar,
                                }}
                                // initialState={{
                                //   sorting: {
                                //     sortModel: [{ field: "legalFieldName", sort: "desc" }],
                                //   },
                                // }}
                                sx={{
                                    p: 2,
                                    boxShadow: 0.5,
                                    border: 0.5,
                                    fontSize: "0.75rem",
                                    borderColor: "dark",
                                }}
                            />
                        </div>
                    </div>
                )}
            </>
        </>
    );
}
